import React from "react";
import { FormControlLabel, Checkbox as MuiCheckbox } from "@mui/material";
import { useCheckBoxStyles } from "./css";

export interface ICheckboxExampleState {
  disabled?: boolean;
  checked?: boolean;
  value: any;
  label: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rightElement?: React.ReactNode;
  slotProps?: { typography?: { [key: string]: any } };
}

const Checkbox = React.forwardRef<any, ICheckboxExampleState>((props, ref) => {
  const { label, onChange, value, rightElement, ...rest } = props;
  const { classes } = useCheckBoxStyles();

  return (
    <div className={classes.grid}>
      <FormControlLabel
        label={label}
        ref={ref}
        control={
          <MuiCheckbox
            color="primary"
            onChange={onChange}
            value={value}
            size="small"
          />
        }
        {...rest}
      />
      {rightElement}
    </div>
  );
});

export default Checkbox;
